/**
 *
 * ActionPlans
 *
 */

import React from "react"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import classNames from "classnames"
import Tracking from "./Tracking"
import Recommendations from "./Recommendations"
import { isEqual } from "lodash"
import "./index.less"
import {
  ROLE_AMBASSADOR,
  ROLE_COMPANY_ADMIN,
  ROLE_COMPANY_SUPER_ADMIN,
  ACTION_PLANS,
  DISABLE,
  PROMO,
  RECOMMENDATIONS,
} from "../../utils/constants"
import BlockFreemiumPageBlur from "components/BlockFreemiumPageBlur"
import {
  isModeInModuleBySlug,
  LOCAL_ACTIVE_ROL,
  LOCAL_USER_ID,
  LOCAL_USER_NAME,
  LOCAL_ONBOARDING,
  LOCAL_PDA_IA_ENABLED,
  LOCAL_NEW_PDA_IA_NOTIFICATION,
  isAdmin,
} from "../../utils/storage"
import { loadTexts } from "../../utils/i18n"
import { buttonAction_btns } from "../../components/Snowplow/config2"
import ModalPdaIaNotification from "../../components/ModalPdaIaNotification"
import { RoleSelector } from "../RoleSelector"
import AdminiIframeBanner from "../../components/AdminIframeBanner"

/* eslint-disable react/prefer-stateless-function */
let view_seguimiento = false
export default class ActionPlans extends React.Component {
  intl = loadTexts("tracking")
  state = {
    tabSelected: 0,
    tabs: [
      {
        name: this.intl.actionPlans.tabOptions.tracking,
        access: [1, 2, 3, 4, 5],
      },
      {
        name: this.intl.actionPlans.tabOptions.recommendations,
        access: [1, 2, 3, 4],
      },
    ],
    header_count: {
      show: false,
      number: 0,
    },
    isModalVisible: true,
    forceStuck: false,

  }

  UNSAFE_componentWillMount = () => {
    const isAmbassador = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
    const isAdministrator = !!(
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_ADMIN
    )

    if (window.Appcues) {
      view_seguimiento = true
    }
  }

  updateCountHeader = (data) => {
    if (!isEqual(this.state.header_count, data))
      this.setState({ header_count: data })
  }

  renderTab = () => {
    let { tabSelected } = this.state
    const actionPlans = isModeInModuleBySlug(ACTION_PLANS)
    const recommendations = isModeInModuleBySlug(RECOMMENDATIONS)
    if (
      (tabSelected === 0 && actionPlans === PROMO) ||
      (tabSelected === 1 && recommendations === PROMO)
    ) {
      return (
        <BlockFreemiumPageBlur
          topHeight={142}
          top={88}
          position="absolute"
          view={tabSelected === 0 ? "action-plans" : "recommendations"}
        />
      )
    }
    switch (tabSelected) {
      case 0:
        if (view_seguimiento) {
          buttonAction_btns("Ir a Seguimiento")
          view_seguimiento = false
        }

        return (
          <Tracking
            forceStuck={this.state.forceStuck}
            history={this.props.history}
            setCountTitle={(data) => this.updateCountHeader(data)}
          />
        )
      case 1:
        view_seguimiento = true
        buttonAction_btns("Ir a Recomendaciones")
        return (
          <Recommendations
            setCountTitle={(data) => this.updateCountHeader(data)}
          />
        )
    }
  }
  setVisible = (visible) => {
    this.setState({ isModalVisible: visible });
  }

  closeIframeBanner = () => {
    this.setState({ forceStuck: true })
  }
  
  render() {
    const { tabSelected, tabs, header_count } = this.state
    const isActionPlans = isModeInModuleBySlug(ACTION_PLANS) !== DISABLE
    const isRecommendations = isModeInModuleBySlug(RECOMMENDATIONS) !== DISABLE
    const isConditionMet =  LOCAL_ONBOARDING() &&  LOCAL_ONBOARDING() != "false" && JSON.parse(LOCAL_ONBOARDING()).some(item => 
       item.step > 5
    );

    const hash = sessionStorage.getItem("hash")
    
    return (
      <Layout>
         { LOCAL_ONBOARDING() != "false"  && LOCAL_PDA_IA_ENABLED() && LOCAL_NEW_PDA_IA_NOTIFICATION() &&
      <ModalPdaIaNotification visible={this.state.isModalVisible} setVisible={this.setVisible} />
    }
        <Helmet>
          <title>{this.intl.actionPlans.titlePage}</title>
          <meta name="description" content="Description of ActionPlans" />
        </Helmet>
        <div
          className="ActionPlans"
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 60,
          }}>
          <div className="ActionPlans-Header">
            {(isAdmin() && (window.top !== window.self)) && <AdminiIframeBanner onClose={this.closeIframeBanner} adminHash={hash} />}
            <div className="ActionPlans-Header-title title_section">
              {`${this.intl.actionPlans.headerTitle} `}
              {header_count.show && (
                <span
                className="title_section">
                  ({header_count.count})
                </span>
              )}
              <RoleSelector sourcePage='pdas'/>
            </div>
            <div className="ActionPlans-Header-tabs">
              {tabs.map((tab, tabIndex) => {
                if (
                  (tabIndex === 0 && isActionPlans) ||
                  (tabIndex === 1 && isRecommendations)
                )
                  return (
                    <span
                      key={tabIndex}
                      className={classNames("ActionPlans-Header-tabs-item", {
                        active: tabSelected === tabIndex,
                      })}
                      onClick={() =>
                        this.setState({
                          tabSelected: tabIndex,
                          header_count: { show: false, count: 0 },
                        })
                      }>
                      {tab.name}
                    </span>
                  )
              })}
            </div>
          </div>
          <div>{this.renderTab()}</div>
        </div>
      </Layout>
    )
  }
}

